import { useMemo } from 'react';
import type { ReactNode } from 'react';
import { ThemeProvider } from 'styled-components';
import { usePrefsStore } from '@/core/stores/prefsStore';
import { darkTheme, lightTheme } from './tokens';
import { GlobalStyle } from './GlobalStyle';
import { applyPreferences } from './applyPreferences';

export function AppThemeProvider({ children }: { children: ReactNode }) {
  const prefs = usePrefsStore((s) => s.prefs);
  const base = prefs.themeMode === 'dark' ? darkTheme : lightTheme;
  // Memoised: applyPreferences now runs the card-colour band solve (bisection) and builds
  // the grain data-URI, so recomputing it on every render — and handing every styled
  // component a new theme identity — is not acceptable.
  const theme = useMemo(() => applyPreferences(base, prefs), [base, prefs]);
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle $reduceMotion={prefs.reduceMotion} />
      {children}
    </ThemeProvider>
  );
}
